import { Pipe, PipeTransform } from '@angular/core';
import { Nalgene } from './nalgene';
import { Certification } from './certification';

@Pipe({
  name: 'CertificationsPipe'
})
export class CertificationsPipe implements PipeTransform {
//   transform(id: number) {

//     return 23;
    
        
//   }
    transform(certifications: Certification[]){
        let output: string[] = [];
        certifications.forEach(element => {
            output.push(element.name);
        });

        return output.join("|");
    }
       
}


// WEBPACK FOOTER //
// /Users/thomas.obrien2/projects/nalgene/src/app/categories/certifications.pipe.ts